export default {
  baseUrl : document.head.querySelector("[property~=base-url][content]").content,
  isAdmin : document.head.querySelector("[property~=is-admin][content]").content,
  isPreview : document.head.querySelector("[property~=is-preview][content]").content,
  gaSid : document.head.querySelector("[property~=ga-sid][content]").content,
  gaSource : document.head.querySelector("[property~=ga-source][content]").content,
  gaReadCookie : document.head.querySelector("[property~=ga-read-cookie][content]").content,

  currentUserId : document.head.querySelector("[property~=user-id][content]").content,

  // myServiceUrl : document.querySelector("[property~=myservice-url][content]")?.content,
  // oneLogUrl : document.querySelector("[property~=onelog-url][qontent]")?.content,
};
